# forward to xcolor

import './xcolor': { XColor }

export Color = XColor
